import { Component, inject } from '@angular/core';
import { LanguageComponent } from '../language/language.component';
import { LanguageService } from '../language.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-genemail',
  imports: [],
  templateUrl: './genemail.component.html',
  styleUrl: './genemail.component.css'
})
export class GenemailComponent {
  languageService = inject(LanguageService);
  activatedRoute = inject(ActivatedRoute);
  successMessage: any;
  setSignatureResponse: any;

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((res: any)=>{
      this.setSignatureResponse = res;
    })
  }


}
